import { parseColor } from 'functions/general/color_functions.js';

/**
 * Validates a color cell. Accepts a hex code (e.g. "#dc143c", "#FFF") or a CSS
 * color name (e.g. "crimson") — anything parseColor can resolve. An empty value
 * is allowed (the feature falls back to a default color). Anything else is
 * rejected with a helpful message.
 *
 * @param {{newValue: *}} args
 * @returns {{valid: boolean, message?: string}}
 */
export default function colorValidator(args) {
  const newValue = args.newValue;
  if (!newValue) {
    return { valid: true };
  }
  const parsed = parseColor(newValue);
  if (parsed && parsed.rgb) {
    return { valid: true };
  }
  return {
    valid: false,
    message: 'Enter a valid color — a name (e.g. crimson) or a hex code (e.g. #dc143c).',
  };
}
